import { Modal, Box, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import RanDbUploadModalHeader from './ran_db_upload_modal_header.component';
import DeleteSiteModal from './delete_site_modal_ran_db.component';
import { useAtom } from 'jotai';
import { openReviewForFile } from '../../common/atom/atoms';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '13px',
  outline: 'none',
  width: '90vw', // comment: make modal responsive
  maxHeight: '90vh', // comment: constrain height on small screens
  overflowY: 'auto',
  //   p: 4,
};
export default function RanDbUploadFileReview({ onUploadComplete }) {
  // const handleCloseModal = () => {
  //   setOpen(false);
  // };
  const [open, setOpen] = useAtom(openReviewForFile);
  return (
    <div>
      <Modal
        open={open} // change this to open only for showing
        onClose={(_, reason) => {
          // Don't allow closing on backdrop click or ESC
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
            <IconButton onClick={() => setOpen(false)} aria-label="Close review modal">
              <CancelIcon />
            </IconButton>
          </Box>
          <RanDbUploadModalHeader onUploadComplete={onUploadComplete} />
        </Box>
      </Modal>
      <DeleteSiteModal />
    </div>
  );
}
